
import { EventBus } from '@/event-bus';
import {
  Client,
  IJobItemScheduleModel,
  JobItemCancelModel,
  UserModel,
  UserProfileModel
} from '@/services/api.service';
import { JobItemCancelledMessage } from '@/services/eventbus.models';
import { Component, Vue } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import { required } from 'vuelidate/lib/validators';

import toISODateFormatter from '@/filters/toISOdate.formatter';

@Component({
  props: {
    jobItemSchedule: {
      type: Object as () => IJobItemScheduleModel,
      required: true
    },
    jobItemGid: String,
    jobGid: String,
    jobItemName: String,
    isInDialogMode: Boolean
  },
  filters: {
    toISODate: toISODateFormatter
  }
})
export default class CancelJobItem extends Vue {
  private notes: string = '';
  private addCancellationActivity: boolean = false;
  private currentUser: UserProfileModel | null = null;

  private formIsValid: boolean | null = null;
  private isSubmittingToService: boolean = false;

  @Validations()
  private validations = {
    notes: { required }
  };

  private mounted() {
    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    clientService.getUserProfile().then((data: UserProfileModel) => {
      this.currentUser = data;
    });
  }
  private cancelJobTask() {
    // Do the work here
    this.isSubmittingToService = true;
    // Run the validation
    // @ts-ignore
    this.$v.$touch();
    const me = this;
    // @ts-ignore
    if (me.$v.$invalid) {
      this.formIsValid = false;
      console.log('Submit failed. Form is invalid.');
      this.isSubmittingToService = false;
    } else {
      const item = this.$props.jobItemSchedule;

      console.log('Cancelling job item:');

      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      const cancelModel: JobItemCancelModel = new JobItemCancelModel();
      const user: UserModel = new UserModel();
      user.init(me.currentUser);

      cancelModel.cancelReason = this.notes;
      cancelModel.cancelledByUserGid = user.gid;

      console.log(cancelModel);
      clientService
        .cancelJobItem(this.$props.jobGid, this.$props.jobItemGid, cancelModel)
        .then(data => {
          // @ts-ignore
          this.$Progress.finish();

          // Push out some events to refresh things
          this.$emit('job-item-cancelled', data);
          EventBus.$emit('job-item-cancelled', new JobItemCancelledMessage(me.$props.jobGid, data));
          this.closeModal();
          // @ts-ignore
          this.$awn.success('Job task cancelled.');
        })
        .catch(reason => {
          // @ts-ignore
          this.$Progress.fail();
          // @ts-ignore
          this.$awn.alert('Failed to cancel the job item. \r\n' + reason.message);
        });
    }
  }

  private cancelEdit() {
    this.closeModal();
  }

  private closeModal() {
    if (this.$props.isInDialogMode) {
      this.$modal.hide('modal-jobitem-cancel');
    }
  }
}
